import React from 'react'
import { mount } from 'enzyme'
import DebtFooter from '../DebtFooter'

describe('<DebtFooter />', () => {
  let wrapper, props
  beforeEach(() => {
    props = {
      left: 'left',
      right: 'right',
      title: 'title'
    }
    wrapper = mount(<DebtFooter {...props} />)
  })
  it('should render', () => {
    mount(<DebtFooter {...props} />)
  })
  it('should render its title prop', () => {
    expect(wrapper.find('DebtFooter__Value').at(0).text()).toBe(props.title)
  })
  it('should render its left prop', () => {
    expect(wrapper.find('DebtFooter__Value').at(1).text()).toBe(props.left)
  })
  it('should render its right prop', () => {
    expect(wrapper.find('DebtFooter__Value').at(2).text()).toBe(props.right)
  })
})
